import React from 'react';
import { createContext } from 'use-context-selector';

import { NotificationKeys, Notifications, notificationMessage } from './type';

export interface ToastNotificationContextType {
  toastOpen: boolean;
  setToastOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleCreateNotification: (type: NotificationKeys, message: React.ReactNode) => void;
  toastNotification: Notifications | null;
}

export const ToastNotificationContext = createContext<ToastNotificationContextType>({} as ToastNotificationContextType);

const TOAST_AUTO_DISMISS_MS = 4500;

export const ToastNotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [toastOpen, setToastOpen] = React.useState(false);
  const [toastNotification, setToastNotification] = React.useState<Notifications | null>(null);
  const dismissTimerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleCreateNotification = (type: NotificationKeys, message: React.ReactNode) => {
    const notification = notificationMessage(message)[type];
    setToastNotification({ message, type: notification.type });
    setToastOpen(true);
    if (dismissTimerRef.current) clearTimeout(dismissTimerRef.current);
    dismissTimerRef.current = setTimeout(() => setToastOpen(false), TOAST_AUTO_DISMISS_MS);
  };

  React.useEffect(() => {
    return () => {
      if (dismissTimerRef.current) clearTimeout(dismissTimerRef.current);
    };
  }, []);

  return (
    <ToastNotificationContext.Provider value={{ toastOpen, setToastOpen, handleCreateNotification, toastNotification }}>
      {children}
    </ToastNotificationContext.Provider>
  );
};
